export const AURORA_SRC = '/images/aurora.webp';
export const AURORA_DESKTOP_QUERY = '(min-width: 1025px)';

const prefersDarkMode = () => {
  try {
    const stored = localStorage.getItem('theme-ui-color-mode');
    if (stored) return stored === 'dark';
  } catch (e) {
    /* private mode / blocked storage — fall through to the media query */
  }
  return (
    typeof window.matchMedia !== 'function' ||
    window.matchMedia('(prefers-color-scheme: dark)').matches
  );
};

export const auroraViewportSupported = () => {
  if (typeof window === 'undefined') return false;
  return (
    typeof window.matchMedia !== 'function' ||
    window.matchMedia(AURORA_DESKTOP_QUERY).matches
  );
};

export const auroraIsEligible = () =>
  auroraViewportSupported() && prefersDarkMode();

let warming = null;

export const warmAurora = () => {
  if (warming) return warming;
  if (typeof window === 'undefined') return Promise.resolve();

  warming = new Promise(resolve => {
    const img = new window.Image();

    const settle = () => resolve();
    const decodeThenSettle = () => {
      if (typeof img.decode === 'function') {
        img.decode().then(settle, settle);
      } else {
        settle();
      }
    };

    img.onload = decodeThenSettle;
    img.onerror = settle;
    img.src = AURORA_SRC;

    if (img.complete) decodeThenSettle();
  });

  return warming;
};

export const warmAuroraWhenIdle = () => {
  if (!auroraIsEligible()) return;

  const run = () => warmAurora();

  if (typeof window.requestIdleCallback === 'function') {
    window.requestIdleCallback(run, { timeout: 2500 });
  } else {
    window.setTimeout(run, 1200);
  }
};
